import { useMemo } from 'react';
import { useItemsStore } from '../store';
import { VisualContent } from '../interfaces/domain/menu';

export const useContentCarousel = () => {
  // 1. SELECTOR ATÓMICO
  const carouselContent = useItemsStore(state => state.carouselContent);

  // 2. PROCESAMIENTO (Filtrado y Ordenado)
  const visibleContent = useMemo(() => {
    return (carouselContent || [])
      .filter(item => item.is_active !== false)
      .sort((a, b) => (a.position ?? 999) - (b.position ?? 999)); // 999 para que los sin posición vayan al final
  }, [carouselContent]);

  const slidesCount = visibleContent.length;

  // 3. LÓGICA DE DUPLICACIÓN (Loop Infinito Safe)
  const slidesToRender = useMemo(() => {
    // Si tenemos 2, duplicamos para que Swiper Loop no falle.
    // Si tenemos 1, Swiper suele comportarse como un banner estático.
    if (slidesCount === 2) return [...visibleContent, ...visibleContent];
    return visibleContent;
  }, [visibleContent, slidesCount]);

  // 4. FLAGS DE UI
  const isCarousel = slidesCount > 1;

  return {
    visibleContent,   // El contenido real (por si necesitas indicadores/dots)
    slidesToRender,    // Lo que efectivamente mapeás en el Swiper
    slidesCount,
    isCarousel,
    shouldRender: slidesCount > 0
  };
};